import * as React from "react";
import { forwardRef } from "react";
const SvgIcDown20 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 13.5859V8H17V16L16 17H8V15H13.5859L2.79297 4.20703L4.20703 2.79297L15 13.5859Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcDown20);
export { ForwardRef as ReactComponent };
